import VueI18n from 'vue-i18n'
import Vue from 'vue'
import { DEFAULT_LANGUAGE, FALLBACK_LANGUAGE } from './trans'
import en from './en.json'
import az from './az.json'
import ru from './ru.json'

Vue.use(VueI18n)

export const i18n = new VueI18n({
  locale: DEFAULT_LANGUAGE, // set locale
  fallbackLocale: FALLBACK_LANGUAGE, // fallback locale if the message is not found
  messages: { en, az, ru }, // set locale messages
  silentTranslationWarn: true, // disable translation missing warnings
  silentFallbackWarn: true, // disable fallback warnings
})
